import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import Translated from "~/Admin/AdminMultilang/Translated";

const AdminEventRaceDayTickets = ({match, event, onChange, ...props}) => {

    const [form, setForm] = useState({
        description: event.race_day_tickets?.description || '',
        info: event.race_day_tickets?.info || '',
        translations: event.race_day_tickets?.translations || {}
    });

    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    const handleSubmit = () => {
        adminHttp
            .put('/events/' + event.id + '/race-day-tickets', form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');

                if (onChange) {
                    onChange();
                }

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    };

    useEffect(() => {
        setForm({
            description: event.race_day_tickets?.description || '',
            info: event.race_day_tickets?.info || '',
            translations: event.race_day_tickets?.translations || {}
        })
    }, [event])

    return (
        <div>
            <div className="card shadow-sm bg-white">
                <div className="card-body">
                    <h3>Race Day Tickets</h3>

                    {message && (
                        <div className="alert alert-success" role="alert">
                            {message}
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving event!"}
                        </div>
                    )}

                    <div className="form-group required">
                        <label className="d-block">Description Copy</label>
                        <small className="d-block">Please provide a description of the tickets guests will get access to.</small>

                        <Translated translations={form.translations}
                                    onChanged={(values) => setForm({...form, translations: values})}>
                                    <textarea
                                        onChange={handleChange}
                                        value={form.description}
                                        rows={10}
                                        name="description"
                                        className="form-control"/>
                        </Translated>

                        <ValidationError errors={error?.errors} name="description"/>
                    </div>

                    <div className="form-group required">
                        <label className="d-block">Useful information</label>
                        <small className="d-block">Please provide key informations related to the guests’ tickets.</small>

                        <Translated translations={form.translations}
                                    onChanged={(values) => setForm({...form, translations: values})}>
                                    <textarea
                                        onChange={handleChange}
                                        value={form.info}
                                        rows={10}
                                        name="info"
                                        className="form-control"/>
                        </Translated>

                        <ValidationError errors={error?.errors} name="info"/>
                    </div>
                </div>
            </div>

            <button
                onClick={handleSubmit}
                className="btn btn-primary text-cta float-right mt-3">
                Save
            </button>
        </div>

    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventRaceDayTickets);
